export default __webpack_public_path__ + "static/waist-be35d3635e3b08844ffa59c97e92b223.svg";